<template>
    <div
        :style="{
            'background-color': timer.backColor,
            background: backColor,
            'font-family': timer.fontFamily,
            'max-width': '100vw',
        }"
    >
        <div
            :data-el-counter="`${timer.endDate} ${timer.endHour}`"
            class="flex justify-center p-4 leading-none"
        >
            <div v-if="showDays" class="mr-6 text-center">
                <p
                    class="mb-2"
                    :style="{
                        color: timer.figColor,
                        'font-size': `${timer.timerSize}px`,
                    }"
                >
                    {{ days }}
                </p>
                <p
                    :style="{
                        color: timer.labelColor,
                        'font-size': `${timer.labelSize}px`,
                    }"
                >
                    {{ timer.langLabels.days }}
                </p>
            </div>
            <div v-if="showHours" class="mr-6 text-center">
                <p
                    class="mb-2"
                    :style="{
                        color: timer.figColor,
                        'font-size': `${timer.timerSize}px`,
                    }"
                >
                    {{ hours }}
                </p>
                <p
                    :style="{
                        color: timer.labelColor,
                        'font-size': `${timer.labelSize}px`,
                    }"
                >
                    {{ timer.langLabels.hours }}
                </p>
            </div>
            <div v-if="showMins" class="mr-6 text-center">
                <p
                    class="mb-2"
                    :style="{
                        color: timer.figColor,
                        'font-size': `${timer.timerSize}px`,
                    }"
                >
                    {{ mins }}
                </p>
                <p
                    :style="{
                        color: timer.labelColor,
                        'font-size': `${timer.labelSize}px`,
                    }"
                >
                    {{ timer.langLabels.minutes }}
                </p>
            </div>
            <div v-if="showSecs" class="text-center">
                <p
                    class="mb-2"
                    :style="{
                        color: timer.figColor,
                        'font-size': `${timer.timerSize}px`,
                    }"
                >
                    {{ secs }}
                </p>
                <p
                    :style="{
                        color: timer.labelColor,
                        'font-size': `${timer.labelSize}px`,
                    }"
                >
                    {{ timer.langLabels.seconds }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TimerBody",
    data() {
        return {
            days: 0,
            hours: 0,
            mins: 0,
            secs: 0,
            currentDiff: 0,
        };
    },
    props: {
        timer: Object,
    },
    computed: {
        backColor() {
            if (this.timer.transparent) {
                return "none";
            } else {
                return this.timer.backColor;
            }
        },
        endDate() {
            return new Date(this.timer.endDate).getTime() || 0;
        },
        showDays() {
            return true;
            //TODO: should be but backend not ready
            // return this.days > 0 || this.currentDiff <= 0;
        },
        showHours() {
            return true;
            //TODO: should be but backend not ready
            //return this.days > 0 || this.hours > 0 || this.currentDiff <= 0;
        },
        showMins() {
            return true;
            //TODO: should be but backend not ready
            // return this.days > 0 || this.hours > 0 || this.mins > 0 || this.currentDiff <= 0;
        },
        showSecs() {
            return true;
            //TODO: should be but backend not ready
            //return (
            //     this.days > 0 ||
            //     this.hours > 0 ||
            //     this.mins > 0 ||
            //     this.secs > 0 ||
            //     this.currentDiff <= 0
            // );
        },
    },
    mounted() {
        this.startCounter();
    },
    methods: {
        startCounter() {
            this.tick();
        },
        tick() {
            const now = new Date().getTime();
            this.currentDiff = this.endDate - now;

            this.days = Math.max(Math.floor(this.currentDiff / (1000 * 60 * 60 * 24)), 0);
            this.hours = Math.max(
                Math.floor((this.currentDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                0
            );

            this.mins = Math.max(
                Math.floor((this.currentDiff % (1000 * 60 * 60)) / (1000 * 60)),
                0
            );
            this.secs = Math.max(Math.floor((this.currentDiff % (1000 * 60)) / 1000), 0);

            setTimeout(this.tick.bind(this), 1000);
        },
    },
};
</script>
